import React from "react";
import styled from "@emotion/styled";
import { chakra } from "@chakra-ui/react";

const StyledCard = styled.div`
  background-color: rgb(30, 29, 45);
  border: 1px solid rgba(255, 255, 255, 0.09);
  box-shadow: rgb(0 0 0 / 5%) 0px 6px 10px;
`;

const CardRoot = chakra(StyledCard);

const Card = (props) => {
  return (
    <CardRoot
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      width="100%"
      borderRadius="8px"
      p={5}
    >
      {props.children}
    </CardRoot>
  );
};

export default Card;
